module.exports = __webpack_public_path__ + "img/icon_red.9482705d.svg";